import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../medieval-office-kit';

/**
 * ROYAL KITCHEN (Кухня) — steamy castle hospitality, the dining/break room of Castle Hearthhold. Warm,
 * busy and savoury: the COOKING HEARTH (a fireplace tucked into the NW corner) throws the third big warm
 * pool on the map, with the bubbling CAULDRON (rendered separately at its anchor) hung in front of it. A
 * prep ISLAND down the south-centre seats three on stools facing the cook; ALE barrels, a cask and a hung
 * rack of HERBS make it read like a working larder, never cold stone.
 *
 * Geometry: zone (40,840) 320×320 → interior x52..348, y852..1148, centre (200,1000). The N-wall door at
 * x200 (gap x140..260) is kept clear — nothing crosses the top-centre.
 */
const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art, f } = ctx;

  // ── HERO: the cooking hearth in the NW corner — the cauldron object sits in its glow (drawn separately). ──
  place(ctx, kit.fireplace(art, 84), 100, 902);

  // ── The prep ISLAND down the south-centre + three working stools facing the cook (-π/2). ──
  place(ctx, kit.feastTable(art, 82), 240, 1012);
  for (const [sx, sy] of [
    [200, 1045],
    [240, 1052],
    [280, 1045],
  ] as const) {
    place(ctx, kit.woodStool(art), sx, sy);
  }

  // ── Larder dressing spread around the room (not stacked in one column): ale barrel NE, a flour barrel
  // filling the centre, a barrel stack + cask flanking the south wall, herbs on the WEST windowsill. ──
  place(ctx, kit.barrel(art), 320, 902); // ale, NE corner
  place(ctx, kit.barrel(art), 158, 956); // flour barrel — fills the centre
  place(ctx, kit.barrelStack(art), 322, 1092); // SE stack
  place(ctx, kit.cask(art), 62, 1092); // SW cask
  place(ctx, f.plant(art, 'fern'), 60, 972); // hanging herbs, west windowsill (clear of the torch)

  // ── Warm edge light: a torch on the east wall (clear of the herbs + the door mouth). ──
  place(ctx, kit.wallTorch(art), 332, 1004);
};

export default decorate;
